import SelectParameter from "./SelectParameter";

const CalculationOnParam = ({ Parameters, selectedParameter, setSelectedParameter, disabled }) => {
    return (
        <div className="calculation-on-param-div">
            <b>Calculation on:</b>
            <SelectParameter
                Parameters={Parameters}
                selectedParameter={selectedParameter}
                setSelectedParameter={setSelectedParameter}
                disabled={disabled}
            />
        </div>
    )
}

export default CalculationOnParam;